import React from "react";
import { useConstructor } from "../hooks/useConstructor";
import FormFullHandler from "../classes/FormFullHandler";
export var FormContext = React.createContext({});
function FormFull(props) {
    var ffHandler = React.useRef();
    useConstructor(function () {
        ffHandler.current = new FormFullHandler({
            onSubmit: props.onSubmit,
            clearOnSubmit: props.clearOnSubmit,
            submitOnClear: props.submitOnClear,
            onChange: props.onChange,
            disabled: props.disabled,
        });
        if (props.currentValues) {
            ffHandler.current.setCurrentValues(props.currentValues);
        }
        if (props.formRef) {
            props.formRef(ffHandler.current);
        }
    });
    React.useEffect(function () {
        var _a, _b;
        (_a = ffHandler.current) === null || _a === void 0 ? void 0 : _a.setCurrentValues((_b = props.currentValues) !== null && _b !== void 0 ? _b : {});
    }, [props.currentValues]);
    React.useEffect(function () {
        var _a, _b;
        (_a = ffHandler.current) === null || _a === void 0 ? void 0 : _a.setFormDisabled((_b = props.disabled) !== null && _b !== void 0 ? _b : false);
    }, [props.disabled]);
    return (React.createElement(FormContext.Provider, { value: ffHandler.current }, props.children));
}
export default FormFull;
